export const isValidImageUrl = (url: string): boolean => {
	return /\.(jpg|jpeg|png|gif|webp|svg)(\?.*)?$/i.test(url);
};
